import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { UserProfile, AppliedPost, ChallanData } from '../layout/fee-challan/fee-challan.interfaces';

@Injectable({
  providedIn: 'root'
})
export class FeeChallanService {
  private readonly apiUrl = '/api/Challan';

  constructor(private http: HttpClient) { }

  getUserProfile(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/GetUserProfile`).pipe(
      map(response => response),
      catchError(error => {
        throw error;
      })
    );
  }

  getAppliedPosts(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/GetAppliedPosts`).pipe(
      map(response => response),
      catchError(error => {
        throw error;
      })
    );
  }

  generateChallan(postId: string): Observable<any> {
    const payload = { postId };
    return this.http.post<any>(`${this.apiUrl}/GenerateChallan`, payload).pipe(
      map(response => response),
      catchError(error => {
        throw error;
      })
    );
  }

  getChallanById(challanId: string): Observable<ChallanData> {
    return this.http.get<ChallanData>(`${this.apiUrl}/challan/${challanId}`);
  }

  updateChallanStatus(challanId: string, status: string, paymentReference?: string): Observable<any> {
    const payload = { status, paymentReference };
    return this.http.put(`${this.apiUrl}/challan/${challanId}/status`, payload);
  }
}